// Currency conversion utilities

// Static exchange rates (will be replaced with live rates in Phase 2)
// Format: How much 1 unit of each currency is worth in USD
export const STATIC_EXCHANGE_RATES = {
  "USD": 1.0,     // Base currency
  "EUR": 1.08,    // 1 EUR = 1.08 USD
  "GBP": 1.27,    // 1 GBP = 1.27 USD
  "INR": 0.012,   // 1 INR = 0.012 USD
  "AED": 0.272,   // 1 AED = 0.272 USD
  "SAR": 0.267,   // 1 SAR = 0.267 USD
  "JPY": 0.0067,  // 1 JPY = 0.0067 USD
  "CNY": 0.138,   // 1 CNY = 0.138 USD
  "AUD": 0.654,   // 1 AUD = 0.654 USD
  "CAD": 0.720    // 1 CAD = 0.720 USD
};

/**
 * Convert an amount from a given currency to USD
 * @param {number} amount - The amount to convert
 * @param {string} currency - The source currency code (e.g., "SAR", "AED")
 * @returns {number} The amount converted to USD
 */
export function convertToUSD(amount, currency) {
  // If amount is null, undefined, or invalid, return 0
  if (amount == null || isNaN(amount)) {
    return 0;
  }
  
  // If no currency specified, assume USD
  if (!currency) {
    return Number(amount);
  }
  
  // Get the exchange rate for the currency
  const rate = STATIC_EXCHANGE_RATES[currency.toUpperCase()];
  
  // If currency not found in rates, assume it's USD
  if (rate === undefined) {
    console.warn(`Currency ${currency} not found in exchange rates, assuming USD`);
    return Number(amount);
  }
  
  // Convert to USD using the exchange rate
  return Number(amount) * rate;
}

/**
 * Calculate the total pipeline value in USD from an array of tenders
 * @param {Array} tenders - Array of tender objects with value and currency properties
 * @returns {number} Total value in USD
 */
export function calculateTotalPipelineValueUSD(tenders) {
  if (!Array.isArray(tenders)) {
    return 0;
  }
  
  return tenders.reduce((acc, tender) => {
    // Skip if tender is null/undefined or archived
    if (!tender || tender.archived === true) {
      return acc;
    }
    
    // Convert the tender value to USD and add to accumulator
    const usdValue = convertToUSD(tender.value, tender.currency || "USD");
    return acc + usdValue;
  }, 0);
}
